import { DateInputRange, formatBalance, TransactionTypeEnum } from '@ui/src';
import BaseStatisticItem from './parts/base-statistics-item';
import { BaseStatisticTypes } from './types';

import cn from './styles.module.css';

const BaseStatistics = ({
  baseStatistic,
  customersTransactionTypes,
  baseCurrency,
  currenciesList,
  baseStatisticDates,
  setBaseStatisticsDate,
  onChangeBaseDates,
  onResetBaseDates,
}: BaseStatisticTypes) => {
  const incomingType = customersTransactionTypes?.find(
    (item) => item.name === TransactionTypeEnum.INCOMING,
  );
  const outgoingType = customersTransactionTypes?.find(
    (item) => item.name === TransactionTypeEnum.OUTGOING,
  );

  const incomingStats = baseStatistic?.find(
    (item) => item.typeId === incomingType?.id,
  );

  const outgoingStats = baseStatistic?.find(
    (item) => item.typeId === outgoingType?.id,
  );

  const currentCurrency = currenciesList?.find(
    (item) => item.id === baseCurrency?.id,
  );

  return (
    <>
      <div className={cn.baseStatisticDatepicker}>
        <DateInputRange
          placeholder="Select Date"
          values={baseStatisticDates.map((date) => date.toISOString())}
          onChangeRange={(dates) => {
            setBaseStatisticsDate(dates);
            onChangeBaseDates(dates);
          }}
          onReset={() => {
            setBaseStatisticsDate([]);
            onResetBaseDates();
          }}
        />
      </div>
      <div className={cn.baseStatisticContent}>
        <div className={cn.baseStatisticBlock}>
          <BaseStatisticItem
            title="Incoming transaction"
            value={incomingStats?.count.toString() as string}
          />
          <BaseStatisticItem
            title="Outgoing transaction"
            value={outgoingStats?.count.toString() as string}
          />
        </div>
        <div className={cn.baseStatisticBlock}>
          <BaseStatisticItem
            title="Av. value incoming payment"
            value={`${formatBalance(
              incomingStats?.avgValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
          <BaseStatisticItem
            title="Av. value outgoing payment"
            value={`${formatBalance(
              outgoingStats?.avgValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
        </div>
        <div className={cn.baseStatisticBlock}>
          <BaseStatisticItem
            title="Min. value incoming payment"
            value={`${formatBalance(
              incomingStats?.minValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
          <BaseStatisticItem
            title="Max. value incoming payment"
            value={`${formatBalance(
              incomingStats?.maxValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
        </div>
        <div className={cn.baseStatisticBlock}>
          <BaseStatisticItem
            title="Min. value outgoing payment"
            value={`${formatBalance(
              outgoingStats?.minValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
          <BaseStatisticItem
            title="Max. value outgoing payment"
            value={`${formatBalance(
              outgoingStats?.maxValue || 0,
              currentCurrency,
            )} ${baseCurrency?.name}`}
          />
        </div>
      </div>
    </>
  );
};

export default BaseStatistics;
